"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceSourceForLogs = reduceSourceForLogs;
/**
 * Filters and formats source fields from a single list of sources.
 *
 * @param {Array<Object>} sources - The array of source objects to filter.
 * @returns {Array<Object>} An array of filtered source objects.
 */
function reduceSourceForLogs() {
  var sources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sources.map(function (source) {
    return {
      _id: source._id,
      broadcast: source.broadcast,
      role: source.role,
      title: source.title,
      type: source.type,
      user: source.user
    };
  });
}